import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { PaginatedResponse } from 'ah-api-gateways';
import { formatDate, SIMPLE_DATE_WITH_FULL_MONTH_FORMAT } from 'ah-common-lib/src/helpers/time';
import { useManagedListing, defineUseManagedListingProps, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { of } from 'rxjs';

export interface OptionPaymentSchedule {
  date: string;
  sellAmount: number;
  buyAmount: number;
  sellCurrency: string;
  buyCurrency: string;
}

interface OptionPaymentScheduleEmit extends UseManagedListingEmits<OptionPaymentSchedule> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentScheduleListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: [] }),
  },
  data: {
    type: Object as PropType<PaginatedResponse<OptionPaymentSchedule>>,
    required: true,
  },
  ...defineUseManagedListingProps<OptionPaymentSchedule>(),
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;

const formatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 });





const managedListing = useManagedListing<OptionPaymentSchedule>({
  loadDataRequest() {
    return of(props.data);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

return { __sfc: true,formatter, props, emit, managedListing, formatDate, SIMPLE_DATE_WITH_FULL_MONTH_FORMAT, formatCurrencyValue }
}

})